import React from 'react'
import ContentHome from '../components/organisms/content-home/content-home'
import PageLayout from '../components/templates/page-layout/page-layout'

function IndexPage() {
  return (
    <PageLayout>
      <ContentHome />
    </PageLayout>
  )
}

export default IndexPage
